'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminContratsController', ['$scope', '$http', '$timeout', function($scope, $http, $timeout) {

  var API = '/api/contrats-petroliers';

  $scope.contrats       = [];
  $scope.isLoading      = true;
  $scope.showModal      = false;
  $scope.saving         = false;
  $scope.currentPage    = 1;
  $scope.itemsPerPage   = 10;
  $scope.totalItems     = 0;
  $scope.totalPages     = 0;
  $scope.searchQuery    = '';
  $scope.filterType     = '';
  $scope.editingContrat = {};
  $scope.successMsg     = '';
  $scope.errorMsg       = '';

  var searchTimeout;

  function flash(type, msg) {
    $scope[type] = msg;
    $timeout(function() { $scope[type] = ''; }, 3500);
  }

  function filterLocal(list) {
    var q = ($scope.searchQuery || '').toLowerCase();
    var t = $scope.filterType;
    return list.filter(function(c) {
      var matchQ = !q || (c.denomination || '').toLowerCase().indexOf(q) !== -1 || (c.reference || '').toLowerCase().indexOf(q) !== -1;
      var matchT = !t || c.typeContrat === t;
      return matchQ && matchT;
    });
  }

  $scope.loadContrats = function() {
    $scope.isLoading = true;
    $http.get(API)
      .then(function(res) {
        var all = Array.isArray(res.data) ? res.data : (res.data.content || []);
        var filtered = filterLocal(all);
        $scope.totalItems = filtered.length;
        $scope.totalPages = Math.ceil(filtered.length / $scope.itemsPerPage) || 1;
        var start = ($scope.currentPage - 1) * $scope.itemsPerPage;
        $scope.contrats = filtered.slice(start, start + $scope.itemsPerPage);
      })
      .catch(function() { flash('errorMsg', 'Erreur lors du chargement des contrats.'); })
      .finally(function() { $scope.isLoading = false; });
  };

  $scope.onSearch = function() {
    if (searchTimeout) $timeout.cancel(searchTimeout);
    searchTimeout = $timeout(function() { $scope.currentPage = 1; $scope.loadContrats(); }, 350);
  };

  $scope.setPage = function(p) {
    if (p < 1 || p > $scope.totalPages) return;
    $scope.currentPage = p;
    $scope.loadContrats();
  };

  $scope.getPages = function() {
    var pages = [], s = Math.max(1, $scope.currentPage - 2), e = Math.min($scope.totalPages, $scope.currentPage + 2);
    for (var i = s; i <= e; i++) pages.push(i);
    return pages;
  };

  $scope.openModal = function(c) {
    $scope.editingContrat = c ? angular.copy(c) : { status: 'En vigueur' };
    $scope.showModal = true;
  };

  $scope.closeModal = function() { $scope.showModal = false; $scope.editingContrat = {}; };

  $scope.saveContrat = function() {
    if (!$scope.editingContrat.denomination) { flash('errorMsg', 'La dénomination est obligatoire.'); return; }
    $scope.saving = true;
    var req = $scope.editingContrat.id
      ? $http.put(API + '/' + $scope.editingContrat.id, $scope.editingContrat)
      : $http.post(API, $scope.editingContrat);
    req.then(function() {
      $scope.closeModal(); $scope.loadContrats();
      flash('successMsg', $scope.editingContrat.id ? 'Contrat mis à jour.' : 'Contrat créé.');
    })
    .catch(function() { flash('errorMsg', 'Erreur lors de l\'enregistrement.'); })
    .finally(function() { $scope.saving = false; });
  };

  $scope.deleteContrat = function(c) {
    if (!confirm('Supprimer "' + c.denomination + '" ?')) return;
    $http.delete(API + '/' + c.id)
      .then(function() { $scope.loadContrats(); flash('successMsg', 'Contrat supprimé.'); })
      .catch(function() { flash('errorMsg', 'Erreur lors de la suppression.'); });
  };

  $scope.loadContrats();
}]);
